import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ActivityType, TrackerCandidateStatus} from '../../../model';
import {trackerCandidateStatusForId} from '../../../utils';
import {FirstNamePipe} from '../../shared/first-name.pipe';
import {TranslateService} from '@ngx-translate/core';
import {isKnownActivity} from "../tracker-activity.pipe";
import {NameFormatPipe} from "../../shared/name-format.pipe";
import {AppStateService} from "../../shared/app-state.service";

@Component({
  selector: 'tracker-history',
  templateUrl: './tracker-history.component.html',
  styleUrls: ['./tracker-history.component.scss']
})
export class TrackerHistoryComponent implements OnChanges {

  @Input() submittal: Submittal;
  @Input() staff: StaffInfo[];
  @Input() fullHistory: boolean = true;

  agentFirstName: string;
  trackerHistory: TrackerActivity[];
  messages: string[] = [];
  activities: TrackerActivity[] = [];

  constructor(private AppState: AppStateService,
              private Translate: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['staff']) {
      const agent = this.staff && this.staff.find(v => v.agent);
      if (agent) {
        const locale = this.AppState.locale$.getValue();
        this.agentFirstName = FirstNamePipe.apply(NameFormatPipe.apply(agent, locale), locale);
      }
    }
    if (this.submittal) {
      this.trackerHistory = this.submittal.trackerHistory;
      if (this.fullHistory) {
        this.getAllActivities();
      } else {
        this.getActiviesForTrackerStatus();
      }
    }
  }

  private getActiviesForTrackerStatus(): void {
    this.activities = [];
    const status = trackerCandidateStatusForId(this.submittal.statusId);
    if (status === TrackerCandidateStatus.new) {
      for (let activity of this.trackerHistory) {
        if (activity.typeId === ActivityType.SubmittedToClient) {
          this.activities.push(activity);
          break;
        }
      }
    } else if (status === TrackerCandidateStatus.reviewed) {
      for (let activity of this.trackerHistory) {
        if (activity.typeId == ActivityType.ReviewedByClient
          || activity.typeId === ActivityType.ReconsideredByClient
          || activity.typeId === ActivityType.InterviewCanceled) {
          this.activities.push(activity);
          break;
        }
      }
      for (let activity of this.trackerHistory) {
        if (activity.typeId === ActivityType.SubmittedToClient) {
          this.activities.push(activity);
          break;
        }
      }
    } else if (status === TrackerCandidateStatus.interviewing && this.trackerHistory.length) {
      const firstActivity = this.trackerHistory[0];
      const firstActivityId = firstActivity.typeId;
      if (firstActivityId === ActivityType.InterviewRequested) {
        this.messages.push(this.Translate.instant('tracker-activity.interview-scheduling', {agentFirst: this.agentFirstName}));
        this.activities.push(firstActivity);
      } else if (firstActivityId === ActivityType.ClientInterview
        || firstActivityId === ActivityType.InterviewScheduled
        || firstActivityId === ActivityType.SecondInterviewScheduled
        || firstActivityId === ActivityType.ThirdInterviewScheduled) {
        let scheduledActivity: TrackerActivity | null = null;
        let requestedActivity: TrackerActivity | null = null;
        this.trackerHistory.forEach((activity: TrackerActivity) => {
          if (activity.typeId === ActivityType.ClientInterview
            && !requestedActivity && !scheduledActivity) {
            scheduledActivity = activity;
          }
          if ((activity.typeId === ActivityType.InterviewRequested
              || activity.typeId === ActivityType.SecondInterviewScheduled
              || activity.typeId === ActivityType.ThirdInterviewScheduled)
            && !requestedActivity) {
            requestedActivity = activity;
          }
        });
        if (scheduledActivity) {
          this.activities.push(scheduledActivity);
        } else {
          this.messages.push(this.Translate.instant('tracker-activity.interview-scheduled-no-date'));
        }
        if (requestedActivity) {
          this.activities.push(requestedActivity);
        }
      } else if (firstActivityId === ActivityType.ClientInterviewComplete
        || firstActivityId === ActivityType.SecondInterviewComplete
        || firstActivityId === ActivityType.ThirdInterviewComplete) {
        this.activities.push(firstActivity);
      }
    } else if (status === TrackerCandidateStatus.offerExtended) {
      for (let activity of this.trackerHistory) {
        if (activity.typeId === ActivityType.OfferExtended) {
          this.activities.push(activity);
          break;
        }
      }
    } else if (status === TrackerCandidateStatus.notInterested) {
      // show no activity
    }
  }

  getAllActivities(): void {
    this.activities = [];
    for (let activity of this.submittal.trackerHistory) {
      if (isKnownActivity(activity.typeId))
        this.activities.push(activity);
      if (activity.typeId === ActivityType.SubmittedToClient)
        break;
    }
  }
}
